import script from "./AdminContentSnippetsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminContentSnippetsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminContentSnippetsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__